import React from 'react';

import Heading from 'components/reusable/authorization/Heading/Heading.layout';
import { Button } from 'components/reusable/Buttons/Button';
import ButtonsWrap from 'components/reusable/Buttons/ButtonsWrap.styled';

import { AuthorisationFailedProps } from './AuthorisationFailed.types';


export default function AuthorisationFailed(props: AuthorisationFailedProps) {
    const { t } = props;

    return (
        <main>
            <Heading
                pageHeader={t('authorisationFailed.header')}
                iconName="closeCircle"
                iconColor="error.base"
                pageSubheader={t('authorisationFailed.subHeader')}
            />

            <ButtonsWrap>
                <Button onClick={() => props.dispatchFinishWorkflow()} variant="error">{t('common:buttons.redirectBack.text')}</Button>
            </ButtonsWrap>
        </main>
    );
}
